import { useNavigate } from "react-router-dom";

const ProjectCard = ({ project, index = 0, visible = true }) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => {
        navigate(`/projects/${project?._id}`);
        window.scrollTo({ top: "0", behavior: "smooth" });
      }}
      className="cursor-pointer group transition-all duration-500"
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(40px)",
        transitionDelay: `${index * 80}ms`,
      }}
    >
      {/* Image */}
      <div
        className="relative rounded-xl overflow-hidden"
        style={{ height: "250px" }}
      >
        <img
          src={project.images?.[0]}
          alt={project.name}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
        />

        {/* Hover overlay */}
        <div
          className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          style={{
            background:
              "linear-gradient(160deg, rgba(192,32,208,0.18), rgba(100,0,120,0.3))",
          }}
        />

        {/* Top accent line */}
        <div
          className="absolute top-0 left-0 right-0 h-0.5 scale-x-0 opacity-0 group-hover:scale-x-100 group-hover:opacity-100 transition-all duration-300"
          style={{
            background: "#e040fb",
            transformOrigin: "left",
          }}
        />
      </div>

      {/* TEXT */}
      <div className="text-left mt-3 px-2 overflow-hidden">
        <p className="text-[#041122] font-bold text-sm sm:text-base lg:text-lg tracking-wide">
          {project.name}
        </p>
        <p className="text-gray-500 text-xs md:text-sm mt-1 leading-tight line-clamp-1">
          {project.description}
        </p>
      </div>
    </div>
  );
};
export const ProjectSkeleton = () => {
  return (
    <div className="animate-pulse">
      <div className="rounded-xl bg-gray-200" style={{ height: "250px" }} />

      <div className="text-center mt-3 px-2 space-y-2">
        <div className="h-3 bg-gray-200 rounded w-1/2 mx-auto" />
        <div className="h-3 bg-gray-200 rounded w-3/4 mx-auto" />
      </div>
    </div>
  );
};

export default ProjectCard;
